import { Space, Text } from "@mantine/core";
import { Button } from "@jem-open/jem-ui";
import React from "react";

type EmptyStateContainerProps = {
  title: string;
  description: string;
  button?: EmptyStateButtonProps;
  numberOfSpaces?: number;
};

type EmptyStateButtonProps = {
  onClick: () => void;
  title: string;
};

const EmptyStateContainer: React.FC<EmptyStateContainerProps> = ({
  title,
  description,
  button,
  numberOfSpaces = 3,
}) => (
  <>
    {Array.from({ length: numberOfSpaces }, (_, index) => (
      <Space key={index} h="xl" />
    ))}

    <div className="empty-state">
      <div className="empty-state-container">
        <Text className="empty-state-heading">{title}</Text>
        <Text className="empty-state-paragraph">{description}</Text>
        {button && (
          <Button
            type="button"
            onClick={button.onClick}
            variant="primary"
            className="btn-text"
          >
            {button.title}
          </Button>
        )}
      </div>
    </div>
  </>
);

export default EmptyStateContainer;
